import { render, staticRenderFns } from "./container-and-pillar-table-guide.vue?vue&type=template&id=52a48af6&"
import script from "./container-and-pillar-table-guide.vue?vue&type=script&lang=js&"
export * from "./container-and-pillar-table-guide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports